var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortingIconBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.78584 14.2658C6.78584 14.4824 6.6102 14.6581 6.39353 14.6581C6.17686 14.6581 6.00122 14.4824 6.00122 14.2658V2.69151L2.63325 6.0526C2.47984 6.20569 2.23138 6.20548 2.07824 6.05212C1.92502 5.89868 1.92524 5.65008 2.07873 5.49691L6.34758 1.23714C6.50946 1.0756 6.78584 1.19025 6.78584 1.41894V14.2658Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57903 14.7626C9.4171 14.9242 9.14062 14.8095 9.14062 14.5807V1.7341C9.14062 1.51744 9.31627 1.3418 9.53293 1.3418C9.7496 1.3418 9.92524 1.51744 9.92524 1.7341V13.3084L13.2936 9.94726C13.447 9.79419 13.6954 9.79445 13.8485 9.94785C14.0016 10.1013 14.0013 10.3497 13.8479 10.5028L9.57903 14.7626Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIconBlack);
export default __webpack_public_path__ + "static/media/sorting-icon-black.91e894c71e0ea77d6787eae9962e17d4.svg";
export { ForwardRef as ReactComponent };